var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"px-3 mt-1"},[_c('wallet-balance')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }